import { PROXY_ENDPOINTS } from "shared/constants/proxy";

export enum ROUTES {
    CATEGORIES,
    PDP,
    PDP_WITH_ID,
    GET_CUSTOMER,
    WIDGETS,
    NOTIFY_ME,
    COUNTRY_CURRENCY_SETTINGS,
    SET_COUNTRY_CURRENCY_SETTINGS,
    SET_COUNTRY_CURRENCY_SETTINGS_ON_SERVER,
    ADD_TO_CART,
    LOGIN,
    REGISTER,
    FORGOT_PASSWORD,
    SOCIAL_AUTH,
    NEWSLETTER,
    HOME,
    AD_PLATFORM_API,
    SEARCH_AUTO_SUGGEST,
    OFFERS,
    FAVICON,
    MINI_CART,
    GDPR_STATUS,
    SET_GDPR,
    SET_COOKIE_CONSENT,
    LISTING,
    TRENDING_SEARCHES,
    PDP_OFFERS,
    GENERATE_OTP,
    RESEND_OTP,
    LINK_MOBILE_TO_ACCOUNT,
    LINK_EMAIL_TO_ACCOUNT,
    MERGE_ACCOUNT,
    ASSOCIATED_EMAILS_WITH_ACCOUNT,
    LOGIN_USING_OTP,
    CREATE_EMAIL_FOR_REGISTERED_MOBILE,
    A_PLUS_CONTENT,
    PIN_CODE_SERVICE,
    PDP_EXPLORE,
    CHECK_USER_EXISTS,
}

export const urls: { [key: string]: string } = {
    [ROUTES.PDP]: "/rest/appapi/V2/products/",
    [ROUTES.PDP_WITH_ID]: "/rest/appapi/V2/products/id/",
    [ROUTES.WIDGETS]: "/rest/appapi/V2/getProductWidgets",
    [ROUTES.CATEGORIES]: "/rest/appapi/V2/categories",
    [ROUTES.GET_CUSTOMER]: "/rest/appapi/V1/customer",
    [ROUTES.ADD_TO_CART]: "/rest/appapi/V1/carts/mine/items",
    [ROUTES.NOTIFY_ME]: "/rest/appapi/V1/product/notifyMe",
    [ROUTES.COUNTRY_CURRENCY_SETTINGS]: "/rest/appapi/V1/getCountryCurrency",
    [ROUTES.SET_COUNTRY_CURRENCY_SETTINGS]: "/SetCookieCurrency.php",
    [ROUTES.LOGIN]: "/customcustomer/account/loginPost",
    [ROUTES.REGISTER]: "/customcustomer/account/createPost",
    [ROUTES.FORGOT_PASSWORD]: "/customcustomer/account/forgotPasswordPost",
    [ROUTES.SOCIAL_AUTH]: "/auth/service.php",
    [ROUTES.NEWSLETTER]: "/couponpost/subscriber/newaction",
    [ROUTES.SET_COUNTRY_CURRENCY_SETTINGS_ON_SERVER]: "/directory/currency/switch",
    [ROUTES.HOME]: "/?ptype=homepage",
    [ROUTES.AD_PLATFORM_API]: "/inventory/data/json/",
    [ROUTES.SEARCH_AUTO_SUGGEST]: "/rest/appapi/V2/search/suggestion",
    [ROUTES.OFFERS]: "/rest/appapi/V1/offers",
    [ROUTES.FAVICON]:
        "https://adn-static1.nykaa.com/nykdesignstudio-images/pub/media/favicon/stores/1/nds_-_favicon.png",
    [ROUTES.MINI_CART]: "/customcart/minicart/index",
    [ROUTES.SET_GDPR]: "/rest/appapi/V1/setCustomergdprOpt",
    [ROUTES.SET_COOKIE_CONSENT]: "/cookie_accept.php",
    [ROUTES.LISTING]: "/rest/appapi/V2/categories/products",
    [ROUTES.TRENDING_SEARCHES]: "/rest/appapi/V2/search/custom",
    [ROUTES.PDP_OFFERS]: "/gateway-api/offer/api/v1/product/<PRODUCT_ID>/offer",
    [ROUTES.GENERATE_OTP]: "/webscripts/api/otp/generate",
    [ROUTES.RESEND_OTP]: "/webscripts/api/otp/resend",
    [ROUTES.LINK_MOBILE_TO_ACCOUNT]: "/webscripts/api/customer/linkMobileToAccount",
    [ROUTES.LINK_EMAIL_TO_ACCOUNT]: "/webscripts/api/pub/customer/linkAccount",
    [ROUTES.MERGE_ACCOUNT]: "/webscripts/api/pub/customer/mergeAccount",
    [ROUTES.ASSOCIATED_EMAILS_WITH_ACCOUNT]: "/webscripts/api/pub/customer/mine",
    [ROUTES.LOGIN_USING_OTP]: "/webscripts/api/pub/customer/login",
    [ROUTES.CREATE_EMAIL_FOR_REGISTERED_MOBILE]: "/webscripts/api/pub/customer/register",
    [ROUTES.A_PLUS_CONTENT]:
        "/rest/appapi/V2/products/specific?fields=aplus_description&product_id=",
    [ROUTES.PIN_CODE_SERVICE]: "/rest/appapi/V1/service/pincode",
    [ROUTES.PDP_EXPLORE]: "/product/<PRODUCT_ID>/posts/",
    [ROUTES.CHECK_USER_EXISTS]: "/rest/appapi/V1/integration/checkCustomerExists",
};

export const getAPIHost = () => {
    return __SERVER__ ? process.env.API_INTERNAL_HOST : process.env.API_HOST;
};

export const getUrl = (uri: ROUTES): string => {
    return `${getAPIHost()}${urls[uri]}`;
};

export const getAdPlatformURL = (uri: ROUTES): string => {
    return `${process.env.AD_PLATFORM_HOST}${urls[uri]}`;
};

export const getExploreURL = (uri: ROUTES) => {
    if (process.env.NODE_ENV === "development") {
        return `${getAPIHost()}/${PROXY_ENDPOINTS.EXPLORE}${urls[uri]}`;
    }

    return `${process.env.EXPLORE_PLATFORM_HOST}${urls[uri]}`;
};
